<template>
  <div class="basicInformation common_group">
    <div class="title">
      <img src="@/assets/images/informationIcon.png">
      <span>基础信息</span>
    </div>
    <el-form class="common_form" label-position="left" ref="clueBasicDataForm" :rules="rules" label-width="140px" :model="formData">
      <el-row>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item label="线索编号">
            <div class="text">{{ basicData.leadId }}</div>
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item label="线索分类">
            <div class="text">{{ basicData.leadTypeName }}</div>
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item label="线索名称" prop="leadName">
            <commonTooltip ref-name="basicDataLeadName" :content="basicData.leadName" v-if="!editFlage" />
            <!-- <div class="text" :title="basicData.leadName" v-if="!editFlage">{{ basicData.leadName }}</div> -->
            <el-input v-model="formData.leadName" maxlength="20" :disabled="!editPermission" v-else />
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item label="线索来源">
            <div class="text">{{ basicData.leadSourceName }}</div>
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item label="是否MQL">
            <div class="text">{{ basicData.isMql }}</div>
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item label="是否SQL">
            <div class="text">{{ basicData.isSql }}</div>
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item label="原始线索分级">
            <div class="text">{{ basicData.classificationOriginalName }}</div>
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item label="实际线索分级">
            <div class="text" v-if="!editFlage">{{ basicData.classificationActualName }}</div>
            <el-select v-model="formData.classificationActualCode" :disabled="!editPermission" placeholder="请选择" v-else>
              <el-option v-for="(item, index) in gradeList" :key="index" :label="item.fieldValue" :value="item.fieldKey" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item label="线索录入人">
            <div class="text">{{ basicData.createUserName }}</div>
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item label="线索上传日期">
            <div class="text">{{ basicData.createTime }}</div>
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item label="线索获得日期">
            <div class="text">{{ basicData.acquireTime }}</div>
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item label="线索验证结果">
            <div class="text">{{ basicData.verifyResultName }}</div>
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item label="线索反馈结果">
            <div class="text">{{ basicData.feedbackResultName }}</div>
          </el-form-item>
        </el-col>
        <el-col v-if="basicData.feedbackResultCode === '3'" :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item label="下单金额">
            <div class="text">{{ basicData.qdOrderAmount ? basicData.qdOrderAmount.toFixed(2) : '' }}</div>
          </el-form-item>
        </el-col>
        <el-col v-if="basicData.feedbackResultCode === '4'" :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item label="线索关闭原因">
            <div class="text">{{ basicData.closeReasonRemark }}</div>
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item label="页面标题">
            <commonTooltip ref-name="basicDataTitle" :content="basicData.title" />
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item label="表单ID">
            <div class="text">{{ basicData.formId }}</div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import commonTooltip from '@/components/commonTooltip';
import { roleManagementApi } from '@/views/backStageManagement/service';
import { arrayQuery } from '@/utils/utils';

export default {
  data () {
    return {
      rules: {
        leadName: [
          { required: true, message: '请输入线索名称', trigger: 'blur' }
        ]
      },
      formData: {},
      basicData: {},
      subdivideActivityTypeList: [],
      editFlage: false,
      leadNameRequired: false,
      gradeList: []
    };
  },
  props: {
    detailsData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    editPermission: {
      type: Boolean,
      default: false
    }
  },
  components: {
    commonTooltip
  },
  methods: {
    clearEditStatus () {
      this.$refs.clueBasicDataForm.clearValidate();
    },
    getOptionList () {
      roleManagementApi.getConfigureList('线索分级').then(res => {
        if (res.status === '200') {
          this.gradeList = res.data.map(item => {
            item.fieldKey = Number(item.fieldKey);
            return item;
          });
        }
      });
    },
    getFormData () {
      return new Promise((resolve, reject) => {
        this.$refs['clueBasicDataForm'].validate((valid) => {
          if (valid) {
            if (this.formData.classificationActualCode) {
              this.formData.classificationActualName = arrayQuery(this.formData.classificationActualCode, this.gradeList, 'fieldKey').fieldValue;
            }
            resolve(this.formData);
          }
        });
      });
    }
  },
  mounted () {
    this.basicData = JSON.parse(JSON.stringify(this.detailsData.lead));
    if (this.basicData.isMql === 1) {
      this.basicData.isMql = '是';
    } else if (this.basicData.isMql === 0) {
      this.basicData.isMql = '否';
    }
    if (this.basicData.isSql === 1) {
      this.basicData.isSql = '是';
    } else if (this.basicData.isSql === 0) {
      this.basicData.isSql = '否';
    }
    this.formData = JSON.parse(JSON.stringify(this.detailsData.lead));
    this.getOptionList();
  }
};
</script>

<style lang="scss" scoped>

</style>
